import type { FilterLayout } from '@/component/Table/types';
import type { Column } from '@tanstack/react-table';
import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

interface ColumnFilterContextData {
  column?: Column<any>;
  layout?: FilterLayout;
}

const ColumnFilterContext = createContext<ColumnFilterContextData>({});

export const ColumnFilterProvider = ({
  column,
  layout,
  children,
}: {
  column: Column<any>;
  layout: FilterLayout;
  children: ReactNode;
}) => (
  <ColumnFilterContext.Provider
    value={{ column, layout }}
    children={children}
  />
);

export const useColumnFilter = () => useContext(ColumnFilterContext);
